import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom";
import { surveyData } from "../../components/Custom/surveyData"
import { requireAuth } from "../../util/auth"
import { Link } from "./../../util/router";
import { ArrowLeftIcon } from "@heroicons/react/24/solid";
import { useAuth } from "../../util/auth";

const Survey = () => {
  const auth = useAuth()
  const { surveyName } = useParams()
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0)
  const [survey] = useState(surveyData[surveyName])
  const [questions, setQuestions] = useState(survey?.questions || [])
  const [finished, setFinished] = useState(false)
  const [currentQuestion, setCurrentQuestion] = useState(questions[0])
  const [endingDisplay, setEndingDisplay] = useState(null)

  useEffect (() => {
    if (currentQuestionIndex < questions.length) {
      setCurrentQuestion(questions[currentQuestionIndex])
    }

  }, [currentQuestionIndex, questions])

  useEffect(() => {
    if (finished && survey?.endingFunc) {
      // run endingFunc only once
      (async () => {
        const result = await survey.endingFunc(questions, auth.user.email)
        setEndingDisplay(result)
      })()
    }
  }, [finished, questions, auth.user.email, survey])

  if (!survey || !currentQuestion) {
    return (
      <div className="max-w-xl mx-auto p-6 text-center">
        <h2 className="text-2xl font-bold text-red-600">404: Survey Not Found</h2>
        <p className="text-lg mt-4 mb-4">The survey you're looking for doesn't exist.</p>
        <Link to="/dashboard/dashboard">
          <button className="w-full px-4 py-2 bg-green-600 text-white rounded-xl hover:bg-green-700 transition">
            Return to Dashboard
          </button>
        </Link>
      </div>
    );
  }

  const handleAnswer = (value) => {
    setQuestions(prev => 
      prev.map((q, i) => 
        i === currentQuestionIndex ? { ...q, answer: value } : q
      )
    );

    setCurrentQuestionIndex(currentQuestionIndex + 1)
    if (currentQuestionIndex + 1 >= questions.length) {
      setFinished(true)
    }
  }

  function backButton() {
    // TODO: update this to handle strAnswers too
    setQuestions(prev =>
      prev.map((q, i) => {
        if (i === currentQuestionIndex) {
          const { answer, ...rest } = q;
          return rest;
        }
        return q;
      })
    );

    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex(currentQuestionIndex - 1)
    }
  }

  if (finished && endingDisplay) {
    return endingDisplay
  }

  if (currentQuestionIndex + 1 > questions.length) {
    return null // or add a spinner/loading state
  }

  return (
    <div className="max-w-xl mx-auto p-6">
      <h2 className="text-xl font-semibold mb-4">
        Question {currentQuestionIndex + 1 >= questions.length ? questions.length : currentQuestionIndex + 1} of {questions.length}
      </h2>
      <p className="text-lg mb-6">{currentQuestion.question}</p>
      <div>
        {currentQuestion.options.map((option, index) => (
          <button
            key={index}
            onClick={() => handleAnswer(option.value)}
            className="w-full px-4 py-2 bg-green-600 text-white rounded-xl hover:bg-green-700 transition mb-4"
          >
            {option.text}
          </button>
        ))}
      </div>
      <div>
        <button
          onClick={() => backButton()}
          className="w-1/2 block mx-auto px-4 py-2 bg-green-600 text-white rounded-xl hover:bg-green-700 transition mt-8"
        >
          <ArrowLeftIcon className="opacity-70 inline-block w-5 h-5" />
          Back
        </button>
      </div>
    </div>
  )
}

export default requireAuth(Survey)
